//export const BASE_URL = "https://digitalshopuy.com/store-api/";
// export const BASE_URL = "http://localhost:13242/";
export const BASE_URL = "https://api.spotifycentral.store/";
export const MIGRATE_URL = "https://migrate.spotifycentral.store/";
